import { supabase } from "@/lib/supabase/client";
import type { MarketingPreferences } from "./domain";

type FunctionsInvoke = (
  name: string,
  options: {
    body?: Record<string, unknown>;
  },
) => Promise<{
  data: {
    error?: string;
    preferences?: MarketingPreferences;
  } | null;
  error: {
    message?: string;
  } | null;
}>;

function readErrorMessage(
  error: { message?: string } | null,
  data: { error?: string } | null,
  fallbackMessage: string,
) {
  if (error?.message) {
    return error.message;
  }

  if (typeof data?.error === "string" && data.error) {
    return data.error;
  }

  return fallbackMessage;
}

export async function updateMarketingPreferences(params: {
  marketingConsent: boolean;
  nightMarketingConsent: boolean;
  marketingConsentMethod?: string;
  invoke?: FunctionsInvoke;
}) {
  const invoke = params.invoke ?? ((name, options) => supabase.functions.invoke(name, options));
  const { data, error } = await invoke("update_marketing_preferences", {
    body: {
      marketingConsent: params.marketingConsent,
      nightMarketingConsent: params.nightMarketingConsent,
      marketingConsentMethod: params.marketingConsentMethod ?? "settings",
    },
  });

  if (error || data?.error || !data?.preferences) {
    throw new Error(readErrorMessage(error, data, "마케팅 수신 설정을 저장하지 못했습니다."));
  }

  return data.preferences;
}
